export default __webpack_public_path__ + "static/media/UserRfpReportsInactiveLight.e6fad5e9.svg";